<template>
<div>
    <MainBanner v-observe-visibility="{
      throttle: 300}" />

    <OurServices v-scroll-reveal="{ delay: 120 }" v-observe-visibility="{
      callback: visibilityChanged,
      throttle: 300,
    }" :services="DataWeb.specialized.items" />
    <AboutUs v-scroll-reveal="{ delay: 120 }" v-observe-visibility="{
      callback: visibilityChanged,
      throttle: 500,
      intersection: {
        threshold: 0.34
      }
    }" />
    <Community v-scroll-reveal="{ delay: 120 }" v-observe-visibility="{
      callback: visibilityChanged,
      throttle: 500,
      intersection: {
        threshold: 0.34
      }
    }" />

    <MainFooter v-observe-visibility="{
      callback: visibilityChanged,
      throttle: 500,
      intersection: {
        threshold: 0.34
      }
    }" />

</div>
</template>

<script>
import DataWeb from "./../config/data";

import MainBanner from "./../components/sections/MainBanner";
import MainFooter from "./../components/shared/MainFooter";

import OurServices from "./../components/sections/OurServices";
import AboutUs from "./../components/sections/AboutUs";
import OurTech from "./../components/sections/OurTech";
import OurWork from "./../components/sections/OurWork";
import Community from "./../components/sections/Community";

export default {
    name: "HomePage",
    components: {
        MainBanner,
        MainFooter,
        OurServices,
        AboutUs,
        OurTech,
        OurWork,
        Community
    },
    methods: {
        visibilityChanged: (isVisible, entry) => {
            if (isVisible && entry) {
                // window.history.pushState({}, entry.target.id,entry.target.id);
            }
        },
        mainVisibility: (isVisible, entry) => {
            if (isVisible) {
                window.history.pushState({}, entry.target.id, '/');
            }
        }
    },
    data() {
        return {
            DataWeb,
            withPath: false
        };
    }
};
</script>
